import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import injectIntl, { intlShape } from 'common/injectIntl';
import { parseSuggestionResults } from '../lib/format/parseSearchAPIResults';
import SearchAPI from '../lib/api/SearchAPI';

const DEFAULT_CONFIGURATION = {
    enabled: true
};

function handleSectionHeaderOnClick() {
    this.searchSection.focus();
}

function handleSuggestionOnMouseOver({ target }) {
    target.style.backgroundColor = '#DE0D17';
    target.style.color = '#ffffff';
}

function handleSuggestionOnMouseOut({ target }) {
    target.style.backgroundColor = '#ffffff';
    target.style.color = '#77787A';
}

class SearchContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
        this.handleSearchTermEventSuggestion = this.handleSearchTermEventSuggestion.bind(this);
        this.handleSuggestionOnClick = this.handleSuggestionOnClick.bind(this);
        this.handleInputOnBlur = this.handleInputOnBlur.bind(this);

        this.state = {
            searchTerm: '',
            suggestions: []
        };
    }

    handleSearchSubmit(event) {
        event.preventDefault();
        if (this.state.searchTerm) {
            this.setState({ suggestions: [] });
            this.props.router.push(`/search/${encodeURIComponent(this.state.searchTerm)}?v=1979`);
        }
    }

    handleSearchTermEventSuggestion(event) {
        const searchTermQuery = event.target.value;
        // Updating the searchTerm to be used while searching by pressing 'enter' key,
        // and resetting suggestions to 0 for rendering
        // if somebody backspacspaces in the textbox
        this.setState({ searchTerm: searchTermQuery });
        this.setState({ suggestions: [] });

        // Suggestions are only returned when the query is 3 char or more long
        if (searchTermQuery.length > 2) {
            SearchAPI.getSuggestion({ q: searchTermQuery, size: 5, env: 'test' }).then(({ page }) => {
                this.setState({ suggestions: parseSuggestionResults(page) });
            });
        }
    }

    handleSuggestionOnClick(event) {
        this.searchSection.focus();
        const query = event.currentTarget.getAttribute('value');
        this.setState({ searchTerm: query });
        this.props.router.push(`/search/${encodeURIComponent(query)}?v=1979`);
    }

    handleInputOnBlur() {
        // Let the onClick event from the suggestions fire before running the following code
        setTimeout(() => {
            this.setState({ suggestions: [] });
        }, 135);
    }

    render() {
        const { messages, intl: { formatMessage } } = this.props;
        const searchClasses = classNames('search-section', 'icon-font-before', 'icon-search-solid-before', {
            'search-section--hero': this.props.isHero
        });

        let suggestionElements = [];

        if (this.state.suggestions.length !== 0) {
            suggestionElements = this.state.suggestions.map((suggestion) => {
                // If the suggestion is the Section header, a different input element should be returned,
                // one that does nothing on the onClick except keep focus on the input box.
                if (suggestion.localeCompare('Events:') === 0 || suggestion.localeCompare('Videos:') === 0) {
                    return (<input
                        type="text"
                        value={suggestion}
                        onClick={handleSectionHeaderOnClick}
                        style={{ backgroundColor: '#313233', color: '#ffffff' }}
                        readOnly
                    />);
                }
                return (<input
                    type="text"
                    value={suggestion}
                    onClick={this.handleSuggestionOnClick}
                    onMouseOver={handleSuggestionOnMouseOver}
                    onMouseOut={handleSuggestionOnMouseOut}
                    style={{ color: '#77787A' }}
                    readOnly
                />);
            });
        }

        return DEFAULT_CONFIGURATION.enabled ? (
            <section className={searchClasses} style={{ zIndex: 10000000 }}>
                <form onSubmit={this.handleSearchSubmit} >
                    <input
                        type="text"
                        autoComplete="off"
                        placeholder={formatMessage(messages['search.placeholder'])}
                        name="search-section"
                        value={this.state.searchTerm}
                        ref={(input) => { this.searchSection = input; }}
                        onChange={this.handleSearchTermEventSuggestion}
                        onBlur={this.handleInputOnBlur}
                    />
                </form>
                <div style={{ position: 'absolute' }}>
                    {suggestionElements}
                </div>
            </section>
        ) : null;
    }
}

SearchContainer.propTypes = {
    isHero: React.PropTypes.bool,
    router: React.PropTypes.object,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

export default withRouter(injectIntl(SearchContainer));




// WEBPACK FOOTER //
// ./app/search/ElasticSearchContainer.js